import React from 'react';

const HealthCheck = () => {
  return <div>OK</div>;
};

export default HealthCheck;
